<pm-dialog
  dialogTitle="CONSENSUS.EXPORT.TITLE"
  dataTestid="consensus-export-dialog"
  contentClass="h-[576px]"
  [secondaryCtaButtonConfig]="{
    dataTestid: 'consensus-export-cancel',
  }"
  [primaryCtaButtonConfig]="primaryCtaButtonConfig()"
>
  <div class="flex h-full flex-col gap-4">
    <pm-tabs-group
      [options]="tabOptions"
      [initialValue]="activeTab()"
      [fullWidth]="true"
      [queryKey]="undefined"
      [dataTestidPrefix]="'consensus-export-tab'"
      (handleClick)="setActiveTab($event)"
    />

    <div class="flex-1 overflow-y-auto">
      @switch (activeTab()) {
        @case (ConsensusExportTab.NEW) {
          <div class="flex flex-col gap-6">
            <!--
              Scope choice temporarily removed: only the server-side COMPLETE
              export ships for now. The "Export what you see" (current grid view)
              option produced a frontend-only AG-Grid export in a different
              format than the real export and never appeared in the Downloads
              list, which could mislead users. Re-enable by uncommenting the
              radio group below (the `scope` signal + `handleVisibleExport` are
              still wired in the component).
            -->

            @if (hasActiveFilter) {
              <!-- active-filter indicator + opt-in -->
              <div
                class="flex flex-col gap-2 rounded-md border border-surface-neutral p-3"
                data-testid="consensus-export-filter-indicator"
              >
                <span class="text-sm font-medium">
                  {{ 'CONSENSUS.EXPORT.FILTER_ACTIVE' | translate }}
                </span>
                <pm-form-input-checkbox
                  [ngModel]="applyFilters()"
                  (ngModelChange)="applyFilters.set($event)"
                  data-testid="consensus-export-apply-filters"
                >
                  {{ 'CONSENSUS.EXPORT.APPLY_FILTERS' | translate }}
                </pm-form-input-checkbox>
              </div>
            }

            <!-- file format + decimal places -->
            <div class="flex flex-col gap-3">
              <span class="text-sm font-medium">
                {{ 'CONSENSUS.EXPORT.FORMAT_LABEL' | translate }}
              </span>
              <mat-radio-group
                class="flex flex-row gap-4"
                [value]="format()"
                (change)="format.set($event.value)"
                data-testid="consensus-export-format-radio-group"
              >
                <mat-radio-button
                  value="XLSX"
                  [attr.data-testid]="'consensus-export-format-XLSX'"
                  >Excel (XLSX)</mat-radio-button
                >
                <mat-radio-button
                  value="CSV"
                  [attr.data-testid]="'consensus-export-format-CSV'"
                  >CSV</mat-radio-button
                >
              </mat-radio-group>
              <pm-form-field
                class="mt-3"
                label="CONSENSUS.EXPORT.DECIMALS_LABEL"
              >
                <pm-form-input-number
                  [formControl]="decimalDigitsControl"
                  [min]="minDecimalDigits"
                  [max]="maxDecimalDigits"
                  [step]="1"
                  data-testid="consensus-export-decimal-digits"
                />
              </pm-form-field>
            </div>

            @if (aggregationLevels.length > 0) {
              <!-- aggregation level -->
              <div class="flex flex-col gap-3">
                <span class="text-sm font-medium">
                  {{ 'CONSENSUS.EXPORT.AGGREGATION_LABEL' | translate }}
                </span>
                <span class="text-content-default text-xs">
                  {{ 'CONSENSUS.EXPORT.AGGREGATION_HELPER' | translate }}
                </span>
                <mat-radio-group
                  class="flex flex-col"
                  [value]="aggregationSelection()"
                  (change)="aggregationSelection.set($event.value)"
                  data-testid="consensus-export-aggregation-radio-group"
                >
                  @for (
                    level of aggregationOptions;
                    track level;
                    let i = $index;
                    let last = $last
                  ) {
                    <div class="flex gap-3">
                      <div
                        class="relative flex w-4 items-center justify-center"
                      >
                        @if (!last) {
                          <span
                            class="absolute left-1/2 top-[calc(50%_+_0.875rem)] h-[calc(100%_-_1.75rem)] w-px -translate-x-1/2 bg-surface-neutral"
                          ></span>
                        }
                        <span
                          class="flex h-7 w-4 items-center justify-center text-sm font-semibold text-content-title"
                        >
                          {{ i + 1 }}
                        </span>
                      </div>
                      <mat-radio-button
                        class="py-1"
                        [value]="i.toString()"
                        [attr.data-testid]="'consensus-export-aggregation-' + i"
                      >
                        {{ level.name }}
                      </mat-radio-button>
                    </div>
                  }
                  <hr class="my-2 border-border-subdued" />
                  <div class="flex gap-3">
                    <div class="w-4"></div>
                    <mat-radio-button
                      value="leaf"
                      [attr.data-testid]="'consensus-export-aggregation-leaf'"
                    >
                      {{ 'CONSENSUS.EXPORT.AGGREGATION_LEAF' | translate }}
                      <span class="text-content-body-subtle">
                        {{
                          'CONSENSUS.EXPORT.AGGREGATION_LEAF_HINT' | translate
                        }}
                      </span>
                    </mat-radio-button>
                  </div>
                </mat-radio-group>
              </div>
            }
          </div>
        }

        @case (ConsensusExportTab.LIST) {
          <pm-consensus-export-list-tab
            [(selectedExportId)]="selectedExportId"
          />
        }
      }
    </div>
  </div>
</pm-dialog>
